import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ENewReviewStep } from '../../types/newReview';
import { Error } from '../../components/FormCommon/Error';
import { addReviewActions } from '../../actions/newReview/addReviewActions';
import { TThunkDispatch } from '../../types/redux';
import { selectNewReviewFormStep } from '../../selectors/newReview';
import { ReviewFlowContainer } from '../DailyrentNewReview/ReviewFlowContainer/ReviewFlowContainer';
import { RatingsContainer } from '../DailyrentNewReview/Rating';
import { ReviewContainer } from '../DailyrentNewReview/Review';
import { SuccessContainer } from '../DailyrentNewReview/Success/SuccessContainer';

export interface INewReviewModalContentContainerProps {
  onClose(): void;
}

export const DailyrentNewReviewModalContentContainer: React.FC<INewReviewModalContentContainerProps> = props => {
  const dispatch = useDispatch<TThunkDispatch>();
  const step = useSelector(selectNewReviewFormStep);

  const retry = React.useCallback(() => {
    dispatch(addReviewActions());
  }, [dispatch]);

  switch (step) {
    case ENewReviewStep.FlowSelection: {
      return <ReviewFlowContainer />;
    }
    case ENewReviewStep.Rating: {
      return <RatingsContainer />;
    }
    case ENewReviewStep.Review: {
      return <ReviewContainer />;
    }
    case ENewReviewStep.Success: {
      return <SuccessContainer />;
    }
    case ENewReviewStep.Error: {
      return <Error retry={retry} type="Отзыв" />;
    }
  }
};
